import type {AuthModalState} from '@gaia/components/AuthModal';
import {createContext} from 'react';

export type AuthModalContext = (authModal: AuthModalState) => void;

const context = createContext<AuthModalContext>(() => {});

context.displayName = 'AuthModalContext';

export default context;
